import React from "react";
import { motion } from "framer-motion";
import { FiArrowUpRight } from "react-icons/fi";
import SectionHead from "../ui/SectionHead";
import { services } from "../../data/resume";
import { fadeUp, staggerChildren } from "../../utils/motionPresets";
import "./services.css";

const Services = () => (
  <section className="section" id="services">
    <div className="container">
      <SectionHead
        index="02"
        eyebrow="Services"
        title={
          <>
            What I bring
            <br />
            to the <span className="serif">table.</span>
          </>
        }
        lede="One engineer across the whole stack — so interface, API, ERP and infrastructure decisions are made together, not in silos."
      />

      <motion.ol
        className="services"
        variants={staggerChildren}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
      >
        {services.map((service, i) => (
          <motion.li key={service.title} className="service" variants={fadeUp}>
            <span className="service__index mono">0{i + 1}</span>
            <h3 className="service__title">{service.title}</h3>
            <div className="service__body">
              <p>{service.text}</p>
              <ul className="service__tags">
                {service.tags.map((tag) => (
                  <li key={tag} className="chip">
                    {tag}
                  </li>
                ))}
              </ul>
            </div>
            <span className="service__arrow" aria-hidden="true">
              <FiArrowUpRight />
            </span>
          </motion.li>
        ))}
      </motion.ol>
    </div>
  </section>
);

export default Services;
